var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3642_19911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 34.1423C-1.95262 26.3317 -1.95262 13.6685 5.85785 5.85791C5.8573 5.85877 17.3914 20.0001 17.3914 20.0001L5.85785 34.1423Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3922 20L2.65344 10.04C2.19648 10.8343 1.79352 11.6634 1.44727 12.5215L8.90891 20L1.4475 27.4789C1.79344 28.3364 2.19602 29.165 2.65266 29.9587L17.3922 20Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8313 17.3911H17.3913L5.8582 5.85791C4.61539 7.10072 3.53562 8.50627 2.65312 10.0399L12.5937 19.9998L2.65234 29.9584C3.53484 31.4924 4.61508 32.8985 5.8582 34.1416L17.3913 22.6085H39.8313C39.9424 21.7545 40.0005 20.8839 40.0005 19.9998C40.0005 19.1156 39.9424 18.245 39.8313 17.3911Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82227 35.8653C11.1948 38.4576 15.4165 39.9999 19.999 39.9999C29.2395 39.9999 37.015 33.7326 39.31 25.2173H18.4703L7.82227 35.8653Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31 14.7826C37.015 6.26727 29.2395 0 19.999 0C15.4165 0 11.1948 1.54227 7.82227 4.13461L18.4702 14.7826H39.31Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3642_19911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZar);
export default __webpack_public_path__ + "static/media/ZAR.4a8e4816a18c6f06c4f833b49d912f92.svg";
export { ForwardRef as ReactComponent };